// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.model-range-bottom-text {
  display: flex;
  gap: 32px;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  left: 50%;
  transform: translate(-50%);
  -webkit-user-select: none; /* Chrome, Safari, Opera */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  opacity: 0;
  transition: opacity 0.8s ease-in-out;
  color: var(--widget-main-color, black)
}

.model-range-animated-text {
  opacity: 1;
}

.model-range-bottom-text-main {
  font-family: Nunito Sans, serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 1;
  margin: 0;
  letter-spacing: 0em;
  text-align: left;
  text-decoration: none;
  color: var(--widget-main-color, black);
  display: flex;
  align-items: center;
  gap: 8px;
}

.model-range-container {
  width: fit-content;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.model-range-bottom-text-main:hover {
  text-decoration: underline;
  cursor: pointer;
}

@media screen and (max-width: 1520px) {
  .model-range-bottom-text {
    font-size: 16px;
  }
}

@media screen and (max-width: 1023px) {
  .model-range-bottom-text {
    position: relative;
    transform: none;
    left: initial;
  }

  .bottom-text-main {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/bottomText/ui/BottomText.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,0BAA0B;EAC1B,yBAAyB,EAAE,0BAA0B;EACrD,sBAAsB,EAAE,YAAY;EACpC,qBAAqB,EAAE,2BAA2B;EAClD,iBAAiB;EACjB,UAAU;EACV,oCAAoC;EACpC;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".model-range-bottom-text {\n  display: flex;\n  gap: 32px;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  width: 100%;\n  left: 50%;\n  transform: translate(-50%);\n  -webkit-user-select: none; /* Chrome, Safari, Opera */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n  opacity: 0;\n  transition: opacity 0.8s ease-in-out;\n  color: var(--widget-main-color, black)\n}\n\n.model-range-animated-text {\n  opacity: 1;\n}\n\n.model-range-bottom-text-main {\n  font-family: Nunito Sans, serif;\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 1;\n  margin: 0;\n  letter-spacing: 0em;\n  text-align: left;\n  text-decoration: none;\n  color: var(--widget-main-color, black);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.model-range-container {\n  width: fit-content;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.model-range-bottom-text-main:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n@media screen and (max-width: 1520px) {\n  .model-range-bottom-text {\n    font-size: 16px;\n  }\n}\n\n@media screen and (max-width: 1023px) {\n  .model-range-bottom-text {\n    position: relative;\n    transform: none;\n    left: initial;\n  }\n\n  .bottom-text-main {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
